import { render, staticRenderFns } from "./HistoryRow.vue?vue&type=template&id=2ad397ee"
import script from "./HistoryRow.vue?vue&type=script&lang=js"
export * from "./HistoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports